<template>
  <div class="schedule-modern">
    <NavBar />

    <div class="schedule-container">
      <div class="schedule-header">
        <div class="header-content">
          <div class="title-section">
            <h1 class="page-title">
              <i class="fas fa-calendar-alt title-icon"></i>
              Tipos de agendamento
            </h1>

            <p class="page-subtitle">
              Manipule e gerencie os tipos de agendamentos dos residentes
            </p>
          </div>

          <div class="actions-section">
            <v-btn
              class="btn-add-modern"
              @click="$bvModal.show('create-schedule-type')"
            >
              <i class="fas fa-plus mr-2"></i>
              Novo Tipo de Agendamento
            </v-btn>
          </div>
        </div>
      </div>

      <div class="filters-modern">
        <div class="container-modern">
          <div class="table-section">
            <div class="table-card">
              <b-overlay :show="loading" opacity="0.99" class="loading-overlay">
                <v-data-table
                  :headers="headers"
                  :items="schedules_types"
                  item-key="id"
                  :footer-props="{
                    'items-per-page-options': [10, 20, 30],
                    'items-per-page-text': 'Mostrar',
                  }"
                  class="modern-table"
                  :no-data-text="'Nenhum tipo de agendamento encontrado'"
                  :loading="loading"
                  :loading-text="'Carregando tipos de agendamentos...'"
                >
                  <template v-slot:[`item.active`]="{ item }">
                    <span
                      class="status-badge"
                      :class="
                        item.active == 1 ? 'status-active' : 'status-inactive'
                      "
                    >
                      <i
                        :class="[
                          'fas mr-1',
                          item.active == 1
                            ? 'fa-check-circle'
                            : 'fa-times-circle',
                        ]"
                      ></i>

                      {{ item.active == 1 ? "Ativo" : "Inativo" }}
                    </span>
                  </template>

                  <template v-slot:[`item.name`]="{ item }">
                    <p>{{ item.name }}</p>
                  </template>

                  <template v-slot:[`item.type`]="{ item }">
                    <div v-if="item.type == 'PADRAO'">
                      <span class="doc-status sistema">Padrão Sistema</span>
                    </div>

                    <div v-if="item.type == 'CLIENTE'">
                      <span class="doc-status cliente">Cadastrado</span>
                    </div>
                  </template>

                  <template v-slot:[`item.action`]="{ item }">
                    <div v-if="item.type == 'CLIENTE'">
                      <v-btn
                        class="doc-btn"
                        small
                        @click="handleUpdate(item.id)"
                      >
                        <i class="fas fa-pen mr-1"></i>
                        Editar
                      </v-btn>

                      <confirmation-dialog
                        v-if="item.id"
                        small
                        message-title="EXCLUIR TIPO DE AGENDAMENTO"
                        message-body="Tem certeza que deseja excluir este tipo de agendamento?"
                        open-class="btn-modern btn-modern-delete"
                        open-left-icon="fa-trash"
                        open-text="Excluir"
                        @yes="deleteScheduleType(item.id)"
                      />
                    </div>

                    <div v-if="item.type == 'PADRAO'">
                      <p class="no-action">Sem ações disponíveis</p>
                    </div>
                  </template>
                </v-data-table>
              </b-overlay>
            </div>
          </div>
        </div>
      </div>
    </div>

    <CreateModal @create="getSchedulesType" />

    <UpadateModal
      :schedule_type_id="schedule_type_id"
      @update="getSchedulesType"
    />
  </div>
</template>

<script>
import NavBar from "../templates/NavBar";

import CreateModal from "../templates/ScheduleType/CreateModal";

import UpadateModal from "../templates/ScheduleType/UpadateModal";

import ConfirmationDialog from "../templates/Components/ConfirmationDialog";

import toast from "../lib/ToastNotification";

import api from "../services/api";

export default {
  name: "Schedule",
  components: {
    NavBar,
    CreateModal,
    UpadateModal,
    ConfirmationDialog,
  },

  data() {
    return {
      loading: false,

      schedule_type_id: null,

      errors: [],

      schedules_types: [],

      headers: [
        {
          text: "Ativo",
          value: "active",
        },
        {
          text: "Nome",
          value: "name",
        },
        {
          text: "Tipo",
          value: "type",
        },
        {
          text: "Ações",
          value: "action",
        },
      ],
    };
  },

  async created() {
    await this.getSchedulesType();
  },

  methods: {
    async getSchedulesType() {
      try {
        const response = await api.get("/schedule-type/paginate");

        const { schedules_types } = response.data;

        this.schedules_types = schedules_types;
      } catch (error) {
        console.error(error);
      }
    },

    async deleteScheduleType(schedule_type_id) {
      try {
        this.loading = true;

        const id = schedule_type_id;

        let params = { id };

        const response = await api.delete("/schedule-type", { params });

        const { error, message } = response.data;

        if (error) {
          toast(message, "error");
        } else {
          toast(message, "success");

          this.getSchedulesType();
        }

        this.loading = false;
      } catch (error) {
        this.loading = false;

        console.log(error);
      }
    },

    handleUpdate(schedule_type_id) {
      this.schedule_type_id = schedule_type_id;

      this.$bvModal.show("update-schedule-type");
    },
  },
};
</script>

<style scoped>
.schedule-modern {
  min-height: 100vh;
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
}

.schedule-container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 24px;
}

.schedule-header {
  padding: 24px 0;
  background: white;
  border-radius: 0 0 24px 24px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
}

.header-content {
  display: grid;
  grid-template-columns: 1fr auto;
  align-items: center;
  gap: 24px;
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 24px;
}

.page-title {
  font-size: 32px;
  font-weight: 700;
  color: #1e293b;
  margin: 0;
  display: flex;
  align-items: center;
}

.title-icon {
  color: #0f65b0;
  margin-right: 12px;
}

.page-subtitle {
  color: #64748b;
  margin: 4px 0 0 0;
  font-size: 16px;
}

.btn-add-modern {
  background: linear-gradient(135deg, #4e9130 0%, #1e884d 100%) !important;
  color: white !important;
  border: none !important;
  border-radius: 12px !important;
  padding: 12px 24px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  box-shadow: 0 4px 15px rgba(78, 145, 48, 0.3) !important;
  transition: all 0.3s ease !important;
}

.btn-add-modern:hover {
  transform: translateY(-2px) !important;
  box-shadow: 0 6px 20px rgba(78, 145, 48, 0.4) !important;
}

.btn-add-modern:active {
  transform: translateY(0) !important;
}

.container-modern {
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(30, 41, 59, 0.06);
  padding: 5px 24px 1px 15px;
  margin: 25px 0;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 25px;
  height: 100%;
}

.table-section {
  margin-bottom: 32px;
}

.table-card {
  background: #f7fafc;
  border-radius: 18px;
  box-shadow: 0 4px 24px rgba(15, 23, 42, 0.08);
  border: 1px solid #e5e7eb;
  padding: 12px 0 0 0;
  margin-bottom: 24px;
  transition: box-shadow 0.2s;
}

.table-card:hover {
  box-shadow: 0 8px 32px rgba(15, 23, 42, 0.15);
}

.status-badge {
  display: inline-flex;
  align-items: center;
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.status-active {
  background: linear-gradient(135deg, #d1fae5 0%, #a7f3d0 100%);
  color: #059669;
  border: 1px solid #34d399;
}

.status-inactive {
  background: linear-gradient(135deg, #fee2e2 0%, #fecaca 100%);
  color: #dc2626;
  border: 1px solid #f87171;
}

.loading-overlay {
  border-radius: 18px;
  background: rgba(255, 255, 255, 0.7) !important;
}

.modern-table {
  background: transparent !important;
  font-size: 15px;
  color: #374151;
}

/* Thead */
.modern-table >>> .v-data-table thead th {
  background: #f1f5f9 !important;
  color: #0f172a !important;
  font-weight: 700 !important;
  font-size: 13px !important;
  letter-spacing: 0.5px !important;
  text-transform: uppercase !important;
  border-bottom: 2px solid #e5e7eb !important;
  padding: 18px 10px !important;
  border-radius: 0 !important;
}

/* Linhas do corpo */
.modern-table >>> .v-data-table tbody tr {
  background: transparent !important;
  transition: background 0.15s;
}

.modern-table >>> .v-data-table tbody tr:hover {
  background-color: #e0e7ef !important;
}

/* Células do corpo */
.modern-table >>> .v-data-table tbody td {
  padding: 18px 10px !important;
  border-bottom: 1px solid #e5e7eb !important;
  font-size: 15px !important;
  vertical-align: middle !important;
}

.modern-table >>> .v-data-table tbody tr:last-child td {
  border-bottom: none !important;
}

/* Botão de ação dentro da tabela */
.doc-btn {
  background: linear-gradient(135deg, #0f65b0 0%, #1e40af 100%) !important;
  color: #fff !important;
  border: none !important;
  border-radius: 8px !important;
  font-weight: 600 !important;
  font-size: 12px !important;
  text-transform: none !important;
  padding: 7px 17px !important;
  margin-right: 7px;
  box-shadow: 0 2px 8px rgba(15, 101, 176, 0.1) !important;
  transition: all 0.2s;
}

.doc-btn:hover {
  background: linear-gradient(135deg, #1558a7 0%, #1e40af 100%) !important;
  box-shadow: 0 4px 14px rgba(15, 101, 176, 0.18) !important;
  transform: translateY(-1px);
}

.doc-status {
  display: inline-block;
  min-width: 90px;
  padding: 8px 18px;
  border-radius: 14px;
  color: #fff;
  font-weight: 700;
  font-size: 13px;
  margin-left: 4px;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.1);
  letter-spacing: 0.4px;
}

.doc-status.sistema {
  background: linear-gradient(135deg, #0f65b0 0%, #1e40af 80%);
}

.doc-status.cliente {
  background: linear-gradient(135deg, #10b981 0%, #059669 80%);
}

.no-action {
  display: inline-block;
  background: #f1f5f9;
  color: #64748b;
  font-weight: 600;
  font-size: 14px;
  border-radius: 8px;
  padding: 7px 18px;
  margin: 10px 0;
  text-align: center;
  border: 1px solid #e5e7eb;
}

/* Mensagem de nenhum dado */
.modern-table >>> .v-data-table__empty-wrapper {
  color: #64748b !important;
  font-size: 17px !important;
  font-weight: 500 !important;
  background: #f8fafc !important;
  border-radius: 0 0 18px 18px;
}

/* ===== Responsividade ===== */
@media (max-width: 1024px) {
  .header-content {
    grid-template-columns: 1fr;
    gap: 16px;
    text-align: center;
  }
  .page-title {
    justify-content: center;
  }
}

@media (max-width: 900px) {
  .modern-table >>> .v-data-table thead th,
  .modern-table >>> .v-data-table tbody td {
    padding: 13px 6px !important;
    font-size: 13px !important;
  }
  .doc-status {
    min-width: 78px;
    font-size: 12px;
    padding: 7px 10px;
  }
}

@media (max-width: 768px) {
  .schedule-container {
    padding: 0 16px;
  }
  .schedule-header {
    padding: 20px 0;
    margin-bottom: 24px;
  }
  .header-content {
    padding: 0 16px;
  }
  .page-title {
    font-size: 24px;
  }
  .page-subtitle {
    font-size: 14px;
  }
  .btn-add-modern {
    padding: 10px 20px !important;
    font-size: 14px !important;
  }
}

@media (max-width: 480px) {
  .page-title {
    font-size: 20px;
    flex-direction: column;
    gap: 8px;
  }
  .title-icon {
    margin-right: 0;
  }
  .btn-add-modern {
    padding: 8px 16px !important;
    font-size: 13px !important;
    border-radius: 8px !important;
  }
}

/* ===== Filtros ===== */
.filters-modern {
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(30, 41, 59, 0.06);
  padding: 5px 24px 1px 15px;
  margin: 25px 25px;
  display: flex;
  gap: 25px;
}

.filter-label {
  font-size: 16px;
  font-weight: 500;
  color: #1e293b;
  margin-bottom: 6px;
}

.filter-select >>> .vs__dropdown-toggle:focus,
.filter-select >>> .vs__dropdown-toggle:hover {
  border-color: #0f65b0;
}
</style>